var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformanceInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23626_18146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 9.16667C5.5 8.19421 5.88631 7.26157 6.57394 6.57394C7.26157 5.88631 8.19421 5.5 9.16667 5.5H34.8333C35.8058 5.5 36.7384 5.88631 37.4261 6.57394C38.1137 7.26157 38.5 8.19421 38.5 9.16667V34.8333C38.5 35.8058 38.1137 36.7384 37.4261 37.4261C36.7384 38.1137 35.8058 38.5 34.8333 38.5H9.16667C8.19421 38.5 7.26157 38.1137 6.57394 37.4261C5.88631 36.7384 5.5 35.8058 5.5 34.8333V9.16667ZM25.5548 14.0342C24.9077 12.4153 22.5885 12.507 22.0678 14.1698L18.8558 24.4475L18.1445 23.023C17.9907 22.7156 17.7544 22.4572 17.462 22.2765C17.1696 22.0958 16.8327 22.0001 16.489 22H12.8333C12.3471 22 11.8808 22.1932 11.537 22.537C11.1932 22.8808 11 23.3471 11 23.8333C11 24.3196 11.1932 24.7859 11.537 25.1297C11.8808 25.4735 12.3471 25.6667 12.8333 25.6667H15.367L17.589 30.1125C18.3352 31.603 20.5168 31.427 21.0137 29.8375L24.046 20.1337L25.7932 24.5025C26.0737 25.2065 26.7557 25.6667 27.5128 25.6667H31.1667C31.6529 25.6667 32.1192 25.4735 32.463 25.1297C32.8068 24.7859 33 24.3196 33 23.8333C33 23.3471 32.8068 22.8808 32.463 22.537C32.1192 22.1932 31.6529 22 31.1667 22H28.7412L25.5548 14.0342Z",
    fill: "#F77C47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23626_18146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceInsights);
export default __webpack_public_path__ + "static/media/performance-insights.3e14fdcae954646e82f7bcd991aa7ef5.svg";
export { ForwardRef as ReactComponent };